/**
 * @file Planboard drag source tasks component
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { DragSourceTasksBaseComponent } from '../drag-source-tasks-base/drag-source-tasks-base.component';
import { DomainService } from '../../domain.service';
import { ExecutorsService } from '../executors.service';
import { AlertsService } from '../../core/alerts.service';
import { GridService } from '../grid.service';
import { LocalStorageService } from '../../core/local-storage.service';
/** Planboard drag source tasks component */
var PlanboardDragSourceTasksComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PlanboardDragSourceTasksComponent, _super);
    /**
     * Constructs PlanboardDragSourceTasksComponent
     * @param configurationsService The configuration service to get the configuration of this component
     * @param router The router to synchronize query parameters with component state
     */
    function PlanboardDragSourceTasksComponent(domainService, executorsService, alertsService, gridService, localStorageService) {
        var _this = _super.call(this, domainService, executorsService, alertsService, gridService) || this;
        _this.localStorageService = localStorageService;
        /**
         * The names of the available filter sources.
         * @private
         * @memberOf PlanboardGridBarComponent
         */
        _this.filterSources = ['RESOURCE', 'PROJECT'];
        _this._selectedTeam = null;
        _this.initiateExecutors();
        return _this;
    }
    Object.defineProperty(PlanboardDragSourceTasksComponent.prototype, "selectedTeam", {
        get: function () {
            return this._selectedTeam;
        },
        set: function (value) {
            if (this._selectedTeam === value) {
                return;
            }
            this._selectedTeam = value;
            this.refresh();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlanboardDragSourceTasksComponent.prototype, "teamOid", {
        get: function () {
            if (this._selectedTeam == null) {
                return '?';
            }
            return this._selectedTeam['Oid'];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The current source to select a filter entity from.
     * @returns The name of the current source.
     * @memberOf PlanboardGridBarComponent
     */
    PlanboardDragSourceTasksComponent.prototype.currentFilterSource = function () {
        return this.localStorageService.readProperty('local', 'planboard-drag-source-tasks-filter-source', 'RESOURCE', this.filterSources);
    };
    /**
     * Select the next filter source
     * @memberOf PlanboardGridBarComponent
     */
    PlanboardDragSourceTasksComponent.prototype.nextFilterSource = function () {
        // Get the current filter source
        var currentFilterSource = this.currentFilterSource();
        // Find the position of the current filter source
        var position = this.filterSources.indexOf(currentFilterSource) + 1;
        // Last in list
        if (position === this.filterSources.length) {
            position = 0;
        }
        // Update the local storage
        this.localStorageService.updateProperty('local', 'planboard-drag-source-tasks-filter-source', this.filterSources[position], this.filterSources);
    };
    return PlanboardDragSourceTasksComponent;
}(DragSourceTasksBaseComponent));
export { PlanboardDragSourceTasksComponent };
